import React from 'react'
import './Dialog.css'

const Dialog = ({ boldText, regularTextBefore, regularTextAfter, dialogType  }) => {
  
  if(dialogType === "error"){
  return (
    <div className='dialog' style={{border: '1px solid rgb(195, 13, 13)', borderRadius:'7px'}}>
      <div className='icon_container' style={{backgroundColor: 'rgb(195, 13, 13)'}}>
        <img
          className='dialog_icon'
          alt='Error Icon'
          src={require('./../images/icons-exclamation.png')}
          loading="eager"
        />
      </div>
      <div className='dialog_text_container' style={{backgroundColor: 'rgba(195, 13, 13, 0.2)'}}>
        <span className='dialog_text'>
        {regularTextBefore} <b>{boldText}</b> {regularTextAfter}
        </span>
      </div>
    </div>
  );
  }
  if(dialogType === "info"){
    return (
      <div className='dialog' style={{border: '1px solid rgb(0, 30, 0)', borderRadius:'7px'}}>
        <div className='icon_container' style={{backgroundColor: 'rgb(0, 30, 0)'}}>
          <img
            className='dialog_icon rotate'
            alt='Info Icon'
            src={require('./../images/icons-exclamation.png')}
            loading="eager"
          />
        </div>
        <div className='dialog_text_container' style={{backgroundColor: 'rgba(0, 30, 0, 0.2)'}}>
          <span className='dialog_text'>
          {regularTextBefore} <b>{boldText}</b> {regularTextAfter}
          </span>
        </div>
      </div>
    );
  }
  };
  

export default Dialog